import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import SeoHelmets from '../SeoOptimazation/SeoHelmets';
// import CardsPage from '../../CardsPage/CardsPage';
// import TwoRowThreeColumnLayout from '../../../EffectonLoad/TwoThreecolumnLayout';
// import { fetchCourseCard as fetchCoursesByExamBody } from '../../DynamicCourse/api';
import axios from 'axios';
// import { BASE_URL } from '../../../insightConfig/insightConfig';
import { BASE_URL } from '../../insightConfig/insightConfig';
import { Link, useNavigate } from 'react-router-dom';
import aboutimg from "../../Image/aboutimg.png"
import { BsJournals } from 'react-icons/bs';
import { FaUserFriends } from 'react-icons/fa';
import TwoRowThreeColumnLayout from '../EffectonLoad/TwoThreecolumnLayout';

function Books() {
    const [books, setBooks] = useState([]);
    const navigate = useNavigate();
    const authtoken = localStorage.getItem('authtoken');
    console.log("authtoken:", authtoken);
    useEffect(() => {
        // Fetch data from API
        const fetchData = async () => {
            try {
                const response = await axios.get(BASE_URL + '/v2/getBooks');


                setBooks(response.data.books);
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };
        fetchData();

    }, []);
    if (books?.length === 0) {
        return <><TwoRowThreeColumnLayout /></>
        // return <>No Data Found</>
    }


    function isValidUrl(string) {
        try {
            new URL(string);
            return true;
        } catch (_) {
            return false;
        }
    }

    const handleOpenBook = async (book) => {
        if (!authtoken) {
            console.log("User is not authenticated");
            alert("Please login to access the book.");
            navigate('/login');
            return;
        }
        if (book.bookPassword) {
            const userPassword = prompt("Please enter your book unique code:");
            const response = await axios.get(`${BASE_URL}/v2/validateBookUniqueCode/${userPassword}`);
            console.log("Validation Response:", response.data);
            if (response.data.isValid) {
                navigate(`/books/${book.titleHeading}`);
            } else {
                alert("Incorrect Book unique code. Please try again.");
            }
        } else {
            navigate(`/books/${book.titleHeading}`);
        }
    }

    return (
        <>
            <SeoHelmets 
                title="UPSC & Competitive Exam Books | Study Material - Insight IAS" 
                description="Explore our collection of comprehensive books and study material for UPSC, IAS, CUET, NEET, and UGC NET preparation. Quality content by Insight IAS Delhi."
                keywords="IAS books, UPSC study material, CUET preparation books, NEET study guide, UGC NET books"
            />
            <div>
                <div className='AllCardBackground'>
                    <h1 className='AllCard_heading fw-bold fs-4'>Books</h1>
                    <div className='AllCard_Box' >
                        {books?.map((book, index) => (
                            <div className="card Allcard" key={index}>
                                <span to={`/books/${book.titleHeading}`} className='text-decoration-none text-black'>
                                    <img src={isValidUrl(book.image) ? book.image : aboutimg} className="card-img-top" alt={book.courseTitle} style={{ height: "200px" }} />
                                </span>
                                <div className="card-body All-bg">
                                    <span to={`/books/${book.titleHeading}`} className='text-decoration-none text-black'>
                                        <h6 className="fw-bold fs-5">{book.courseTitle}</h6>
                                    </span>
                                    <hr />
                                    <div className="d-flex justify-content-between align-items-center">
                                        <span to="#" className="card-link list-group-item">
                                            <h6 className='d-flex align-items-center'><BsJournals className='me-1' />{book.topicCount || 0} LESSONS</h6>
                                            {/* <h6 className='d-flex align-items-center'><FaUserFriends className='me-1' /> {book.subscribers || 0} SUBSCRIBERS</h6> */}
                                        </span>
                                        <button onClick={() => handleOpenBook(book)} to={`/books/${book.titleHeading}`} /* state={{ isEnrolled: book.isEnrolled }} */ className="btn-start list-group-item">Proceed</button>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </>
    )
}

export default Books;
